import Fader from './libraries/fader';

import App from './app';
import PolyfillController from './controllers/polyfill';

(async () => {
    document.querySelector('html').classList.remove('no-js');

    const polyfills = new PolyfillController();
    await polyfills.init();

    try {
        const app = new App();
        app.resizeThrottle = 10;
        app.scrollThrottle = 100;
        window.app = app;

        app.polyfillController = polyfills;

        // app.AVGController = new AVGController();
        // app.headerController = new HeaderController();

        // Modules
        if (document.querySelector('ul.accordeon:not(.locked), ol.accordeon:not(.locked), div.accordeon:not(.locked)')) {
            import( /* webpackChunkName: "modules/accordeon" */ './controllers/accordeon/controller').then(e => {
                app.accordeonController = new e.default();
            });
        }

        // Fade functionality
        const fades = [];
        fades.push('.fadeElement');

        let loadFader;
        loadFader = () => {
            app.fader = app.fader || new Fader(fades.join(','));
        };
        loadFader();

        await app.init();
        console.log(`App initialized`);
        document.documentElement.classList.remove('preventAnimations');

    } catch (e) {
        console.error(`Something went wrong initializing the app`);
        document.documentElement.classList.remove('preventAnimations');
        throw e;
    };

})();